import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type Brand } from '../../entity/api/brand';
import { createBasicStoreState } from './basic-store';

type TModel = Brand;

/**
 * Brands Zustand Store
 *
 * This store now only provides:
 * - Basic store methods (clearStore, updateToStore, updateMultipleToStore, etc.) for socket updates
 * - Sync state for socket handlers
 *
 * For data fetching and mutations, use TanStack Query hooks from brands-queries.ts:
 * - useBrandsList()
 * - useBrandById(id)
 * - useBrandsByOrgId(orgId)
 * - useBrandJobStatus(brandId)
 * - useCreateBrand()
 * - useUpdateBrand()
 * - useRemoveBrand()
 * - useGenerateBrandContext()
 * - useGenerateBrandContextFromOnboarding()
 */
type FullStoreState = ReturnType<typeof createBasicStoreState<TModel>>;

export const useStore = create<FullStoreState>()(
  devtools(
    function (set, get) {
      return {
        ...createBasicStoreState<TModel>(set, get),
      };
    },
    { name: 'blym', store: 'brands' }
  )
);
